export const GET_EMPLOYEES_API_IS_PENDING = "GET_EMPLOYEES_API_IS_PENDING";
export const GET_EMPLOYEES_API_IS_ERROR = "GET_EMPLOYEES_API_IS_ERROR";

export const GET_EMPLOYEE = "GET_EMPLOYEE";
export const GET_ME = "GET_ME";
export const GET_EMPLOYEE_IS_SUCCESS = "GET_EMPLOYEE_IS_SUCCESS";
export const GET_ME_IS_SUCCESS = "GET_ME_IS_SUCCESS";
